// Login.js
import Form from "./component/Form";


const Login = () => {
  return (
    <div className="w-full max-w-md p-6 bg-white shadow-md rounded-md">
      <Form />
    </div>
  );
};

export default Login;
